import { SET_FEATURE_LIMITS } from 'constants/action_types/accounts/featureLimits'

export const updateFeatureLimit = (
  feature,
  featureLimits
) => async dispatch => {
  dispatch({
    type: SET_FEATURE_LIMITS,
    payload: {
      feature,
      featureLimits
    }
  })
}
